// extracted by mini-css-extract-plugin
module.exports = {"HSApplyContract":"index-module_HSApplyContract_36ppp","title":"index-module_title_1hU4y"};